// extracted by mini-css-extract-plugin
export default {"zoom":"world-zoom_zoom__+CWSp","icon":"world-zoom_icon__8xQ5L"};